import React, { ComponentType, PureComponent } from 'react';
import { Route, RouteComponentProps, withRouter } from 'react-router-dom';
import { BaseProps } from '../components/page-view/types';
import NoPermission from '../components/permission';
import { fomatParentPath } from '../utils';
import './index.less';

export interface RouteNoPermissionProps extends React.Attributes, BaseProps {
  path?: string;
}

class RouteNoPermission extends PureComponent<
  RouteNoPermissionProps & RouteComponentProps<{ id: string }>
> {
  render() {
    const { path } = this.props;
    const parentPath = fomatParentPath(this.props);

    return (
      <Route
        weId={`${this.props.weId || ''}_b7df88`}
        path={path || `${parentPath}/nopermission`}
        component={NoPermission}
        exact
      />
    );
  }
}

export default withRouter(
  RouteNoPermission as any,
) as unknown as ComponentType<RouteNoPermissionProps>;
